<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="tableWrap" style="padding: 40px;">
        <el-form
          ref="form"
          :model="detaildata"
          class="searchForms searchFormPaddings"
        >
          <el-form-item label="活動名稱：" class="searchItem">
            <el-input
              placeholder="請輸入活動名稱"
              v-model="detaildata.activityName"
              maxlength="100"
            ></el-input>
          </el-form-item>

          <el-form-item label="活動類型：" class="searchItem">
            <el-select
              v-model="detaildata.type"
              placeholder="請選擇活動類型"
              @change="handchange"
            >
              <el-option label="一般活動" :value="0"></el-option>
              <el-option label="演唱會" :value="1"></el-option>
              <el-option label="見面會" :value="2"></el-option>
              <el-option label="後臺活動" :value="3"></el-option>
            </el-select>
          </el-form-item>
     
          <el-form-item
            label="核銷操作"
            class="searchItems"
            v-if="detaildata.type == 2"
          >
            <el-checkbox-group v-model="checkList" @change="handleChecked">
              <el-checkbox label="入場"></el-checkbox>
              <el-checkbox label="上臺"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="是否抽獎"
            class="searchItems"
            v-if="detaildata.type == 2"
          >
            <el-switch v-model="isLottery" @change="handswich" />
          </el-form-item>
          <el-form-item
            label="抽獎網址"
            class="searchItems"
            v-if="isLottery && detaildata.type == 2"
          >
            <div style="display: flex;align-items: center;">
              <p>
                <span class="spantext">{{ detaildata.lotteryUrl }}</span
                ><span v-if="!type" class="spantext">{{
                  detaildata.lotteryName
                }}</span>
              </p>
              <el-input
                placeholder="請輸入城市後綴"
                v-model="detaildata.lotteryName"
                maxlength="100"
                style="margin-left: 5px;width: 200px;flex-shrink: 0;"
                v-if="type"
                @input="handinput"
              ></el-input>
              <p
                class="commontext"
                v-throttle="{
                  fn: () => {
                    lotteryUrl('end');
                  },
                  time: 2000
                }"
                v-if="type"
              >
                完成
              </p>
              <p v-if="!type" class="commontext" @click="lotteryUrl('edit')">
                編輯
              </p>
            </div>
          </el-form-item>
          <el-form-item
            label="抽獎結束時間："
            class="searchItems"
            v-if="isLottery && detaildata.type == 2"
          >
            <el-date-picker
              type="datetime"
              placeholder="請選擇抽獎結束時間"
              v-model="detaildata.lotteryEndTime"
              :picker-options="pickerStartTime"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="核銷開始時間：" class="searchItems">
            <el-date-picker
              type="datetime"
              placeholder="請選擇核銷開始時間"
              v-model="detaildata.startTime"
              :picker-options="pickerStartTime"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="核銷結束時間：" class="searchItems">
            <el-date-picker
              type="datetime"
              placeholder="請選擇核銷結束時間"
              v-model="detaildata.endTime"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div style="display: flex;justify-content: center;margin-top: 100px;">
          <div class="button" @click="getSumbit('cancel')">
            取消
          </div>
          <div
            class="button"
            v-throttle="{
              fn: () => {
                getSumbit('confirm');
              },
              time: 2000
            }"
            style="margin-left: 20px;background: #6c3dea;color: #FFFFFF;"
          >
            確定
          </div>
        </div>
      </div>
    </div>
 
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
export default {
  data() {
    return {
      navBlock: "活動 / 核銷活動",
      navtitle: "",
      type: true,
      isLottery: false,
      checkList: [],
      detaildata: {
        activityName: "",
        type: "",
        startTime: "",
        endTime: "",
        isLottery: false,
        lotteryUrl: null,
        lotteryEndTime: null,
        lotteryName: null,
        mode: ""
      },

      nowId:"",
      pickerStartTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 禁用小于当前时间的日期
        }
      }
    };
  },
  created() {
    if (this.$route.query.item) {
      this.detaildata = JSON.parse(decodeURIComponent(this.$route.query.item));
      this.isLottery = this.detaildata.isLottery == 0 ? false : true;
      if (this.detaildata.isLottery == 1) {
        this.type = false;
      } else {
        this.type = true;
      }
      if (this.detaildata.mode == 1) {
        this.checkList = ["入場"];
      } else if (this.detaildata.mode == 2) {
        this.checkList = ["上臺"];
      } else {
        this.checkList = ["入場", "上臺"];
      }
      this.navtitle = "編輯核銷活動";
    } else {
      this.navtitle = "新增核銷活動";
    }
  },

  destroyed() {
    this.$message.closeAll();
  },
  methods: {

    handinput(e) {
      console.log(e);
      const regex = /^[A-Za-z]*$/;
      if (!regex.test(e)) {
        this.detaildata.lotteryName = e.replace(/[^A-Za-z]/g, "");
      }
    },
    handchange(e) {
      this.isLottery = false;
        this.type = true;
        this.detaildata.lotteryUrl = null;
        this.detaildata.lotteryEndTime = null;
        this.detaildata.lotteryName = null;
        this.checkList = [];
    },
    handswich(e) {
      if (!e) {
        this.type = true;
        this.detaildata.lotteryUrl = null;
        this.detaildata.lotteryName = null;
        this.detaildata.lotteryEndTime = null;
      } else {
        this.detaildata.lotteryUrl = this.$GLOBAL.lotteryPostUrl;
      }
    },
    handleChecked(e) {
      console.log(e);
    },
    lotteryUrl(e) {
      if (e == "end") {
        if (this.detaildata.lotteryName) {
          this.type = false;
        } else {
          this.$message({
            message: "請輸入城市後綴",
            type: "warning",
            center: true
          });
        }
      } else {
        this.type = true;
      }
    },
    getSumbit(type) {
      if (type == "cancel") {
        this.$router.go(-1);
      } else {
        if (!this.detaildata.activityName) {
          this.$message({
            message: "請輸入活動名稱",
            type: "warning",
            center: true
          });
          return;
        }
        if (this.detaildata.type === "") {
          this.$message({
            message: "請選擇活動類型",
            type: "warning",
            center: true
          });
          return;
        }
        if(this.detaildata.type==2){
          if (this.checkList.length == 0) {
          this.$message({
            message: "請選擇核销操作",
            type: "warning",
            center: true
          });
          return;
           };
              if (this.checkList.length == 2) {
          this.detaildata.mode = 3;
        } else if (this.checkList[0] == "入場") {
          this.detaildata.mode = 1;
        } else {
          this.detaildata.mode = 2;
        }
        }else{
          this.detaildata.mode=''
        }
        

        if (this.isLottery) {
          if (!this.detaildata.lotteryName) {
            this.$message({
              message: "請輸入城市後綴",
              type: "warning",
              center: true
            });
            return;
          }
          if (this.type) {
            this.$message({
              message: "請先完成城市後綴",
              type: "warning",
              center: true
            });
            return;
          }
          if (!this.detaildata.lotteryEndTime) {
            this.$message({
              message: "請選擇抽獎結束時間",
              type: "warning",
              center: true
            });
            return;
          }
        }
        if (!this.detaildata.startTime) {
          this.$message({
            message: "請選擇核銷開始時間",
            type: "warning",
            center: true
          });
          return;
        } else {
          if (this.$dayjs(this.detaildata.startTime).isBefore(this.$dayjs())) {
            this.$message({
              message: "核銷開始時間不能小於當前時間",
              type: "warning",
              center: true
            });
            return;
          }
        }
        if (!this.detaildata.endTime) {
          this.$message({
            message: "請選擇核銷結束時間",
            type: "warning",
            center: true
          });
          return;
        } else {
          if (
            this.$dayjs(this.detaildata.endTime).isBefore(
              this.$dayjs(this.detaildata.startTime)
            )
          ) {
            this.$message({
              message: "核銷結束時間不能小於核銷開始時間",
              type: "warning",
              center: true
            });
            return;
          }
        }

        this.detaildata.isLottery = this.isLottery ? 1 : 0;
        if (this.detaildata.lotteryEndTime) {
          this.detaildata.lotteryEndTime = this.$dayjs(
            this.detaildata.lotteryEndTime
          ).format("YYYY-MM-DD HH:mm:ss");
        }
        this.detaildata.startTime = this.$dayjs(
          this.detaildata.startTime
        ).format("YYYY-MM-DD HH:mm:ss");
        this.detaildata.endTime = this.$dayjs(this.detaildata.endTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.$post(
          `/write/off/activity`,
          this.detaildata,
          this.$GLOBAL.jsonConfig
        )
          .then(res => {
            if (res.code == "00000") {
              this.$propMessage("操作成功", "success");
              setTimeout(() => {
                this.$router.go(-1);
              }, 500);
            } else {
              console.log(this.isLottery);

              this.$warnMessage(res.message);
            }
          })
          .catch(err => {
            this.$warnMessage("err");
          });
      }
    }
  },
  components: {
    NavBar
  }
};
</script>
<style lang="less" scoped>
.button {
  width: 100px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid;
  cursor: pointer;
}
.commontext {
  cursor: pointer;
  font-size: 14px;
  color: #6c3dea;
  margin-left: 10px;
}
.spantext {
  font-size: 14px;
  font-weight: bold;
}
.dialog {
  display: flex;
  justify-content: center;
  .el-upload__tip {
    color: #65676b;
  }
}
.btngroup {
  margin-top: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  text-align: center;
}
/deep/ .el-dialog {
  border-radius: 12px;
}
/deep/ .el-dialog__header {
  // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}
/deep/ .el-dialog__title {
  font-size: 0.16rem;
}
/deep/ .el-upload__text em {
  color: #6c3dea !important;
}
/deep/ .el-upload-dragger:hover {
  border-color: #6c3dea !important;
}
/deep/ .el-upload-dragger {
  width: 320px !important;
  border: 1px dashed #d9d9d9 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/checkActivity/addActivity.vue